import { Component } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";

import Header from "./components/Header";
import Footer from "./components/Footer";
import FloatingActions from "./components/FloatingActions";
import ScrollToTop from "./components/ScrollToTop";

import Home from "./pages/Home";
import ServicePage from "./pages/ServicePage";
import LocationPage from "./pages/LocationPage";
import SubAreaHub from "./pages/SubAreaHub";
import ServiceSubArea from "./pages/ServiceSubArea";
import ContactPage from "./pages/ContactPage";
import NotFound from "./pages/NotFound";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex flex-col items-center justify-center gap-4 p-8 text-center">
          <h1 className="font-display font-extrabold uppercase text-4xl text-white">
            Something went flat.
          </h1>
          <p className="text-zinc-400">Reload the page to get back on the road.</p>
          <a
            href="/"
            className="btn-glow px-8 py-3 rounded-full bg-[#FF5500] text-black font-telemetry text-xs font-semibold uppercase tracking-[0.15em]"
          >
            Reload
          </a>
        </div>
      );
    }
    return this.props.children;
  }
}

export default function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <ScrollToTop />
        <div className="App page-shell">
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services/:slug" element={<ServicePage />} />
            <Route path="/services/:slug/in/:areaSlug" element={<ServiceSubArea />} />
            <Route path="/areas/:slug" element={<LocationPage />} />
            <Route path="/in/:areaSlug" element={<SubAreaHub />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Footer />
          <FloatingActions />
        </div>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

// Lenis smooth momentum scrolling (initialised once, after router mounts)
(function initLenis() {
  const start = () => {
    if (window.__lenis) return;
    const lenis = new Lenis({ lerp: 0.11, smoothWheel: true });
    window.__lenis = lenis;
    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
  };
  if (document.readyState === "complete" || document.readyState === "interactive") {
    start();
  } else {
    document.addEventListener("DOMContentLoaded", start);
  }
})();
